export const fetchRegistrati = (credentials) => {
  //console.log("fetch " + JSON.stringify(credentials))
  var body = JSON.stringify(credentials);
  var endpoint = global.endpoint + "/pegaso/webAppPegasoRegisterUser";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
};
export const fetchRegistratiNoResult = (credentials) => {
  //console.log("fetch " + JSON.stringify(credentials))
  var body = JSON.stringify(credentials);
  var endpoint = global.endpoint + "/pegaso/webAppPegasoRegisterUser";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  });
};
export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
export const submitForgotPassword = async (e, addToast, email, history) => {
  var endpoint = global.endpoint;
  var body = {};
  body["email"] = email;
  fetch(endpoint + "pegaso/webAppPegasoRecuperaPassword", {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: JSON.stringify(body),
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      var Errore = result.Errore;

      if (Errore == "") {
        addToast("Controlla la mail", {
          appearance: "success",
          autoDismiss: true,
          placement: "bottom-left",
        });
        setTimeout(function () {
          history.push("/");
        }, 2000);
      } else {
        addToast(Errore, {
          appearance: "error",
          autoDismiss: true,
          placement: "bottom-left",
        });
      }
      return result;
    });
};

export const sendMail = (credentials) => {
  var body = JSON.stringify(credentials);
  //console.log("Queste sono le Credenziali");
  //console.log(body);
  var endpoint = global.endpoint + "/pegaso/setContactUS";

  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      //console.log(result);
      return result;
    });
};

export const fetchSendCheckout = (credentials) => {
  ////console.log("fetch " + JSON.stringify(credentials))
  var body = JSON.stringify(credentials);
  var endpoint = "";
  if (global.aziendaID == 1)
    endpoint = global.endpoint + "/pegaso/webAppCheckout";
  if (global.aziendaID == 2)
    endpoint = global.endpoint + "/pegaso/webAppCheckoutMondoCarta";
  if (global.aziendaID == 3)
    endpoint = global.endpoint + "/pegaso/webAppCheckoutSpotClub";
  if (global.aziendaID == 4)
    endpoint = global.endpoint + "/pegaso/webAppCheckoutBetaRicambi";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
};

export const fetchSendCartData = (credentials) => {
  ////console.log("fetch " + JSON.stringify(credentials))
  var body = JSON.stringify(credentials);
  var endpoint = global.endpoint + "/pegaso/getWebAppAdjustCart";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
};

export const fetchProductById = async (credentials) => {
  var body = JSON.stringify(credentials);

  var endpoint = global.endpoint + "pegaso/getProductById";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  });
};
export const fetchAnagrafica = async (credentials) => {
  var body = JSON.stringify(credentials);
  var endpoint = global.endpoint + "pegaso/getWebAppCustomersFromAgent";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
};
export const fetchAnagraficaWithResult = (credentials) => {
  var body = JSON.stringify(credentials);
  var endpoint = global.endpoint + "pegaso/getWebAppCustomersFromAgent";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  });
};

export const changeData = async (credentials, addToast) => {
  //console.log(credentials);
  var body = JSON.stringify(credentials);
  var endpoint = global.endpoint + "/pegaso/webAppPegasoChangeUserData";
  //var endpoint = "http://73.10.23.214:8085/apiPegaso/" + "/pegaso/webAppPegasoChangeUserData";

  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      var Errore = result.Errore;

      if (Errore == "") {
        addToast("Dati modificati con successo...", {
          appearance: "success",
          autoDismiss: true,
          placement: "bottom-left",
        });
      } else {
        addToast(Errore, {
          appearance: "error",
          autoDismiss: true,
          placement: "bottom-left",
        });
      }
      return result;
    });
};

export const uploadFile = (body, addToast) => {
  var endpoint = global.endpoint;
  fetch(endpoint + "uploadFile", {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: JSON.stringify(body),
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      var Errore = result.Errore;

      if (Errore == "") {
        addToast("Foto modificata con successo...", {
          appearance: "success",
          autoDismiss: true,
          placement: "bottom-left",
        });
      } else {
        addToast(Errore, {
          appearance: "error",
          autoDismiss: true,
          placement: "bottom-left",
        });
      }
      return result;
    });
};

export const changePassword = (body, addToast, history) => {
  var endpoint = global.endpoint;
  fetch(endpoint + "webAppPegasoChangePasswordRecupero", {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: JSON.stringify(body),
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      var Errore = result.Errore;

      if (Errore == "") {
        addToast("Password reimpostata correttamente", {
          appearance: "success",
          autoDismiss: true,
          placement: "bottom-left",
        });
        setTimeout(function () {
          history.push("/shop-grid-full-width");
        }, 2000);
      } else {
        addToast(Errore, {
          appearance: "error",
          autoDismiss: true,
          placement: "bottom-left",
        });
      }
      return result;
    });
};
export const fetchRecensione = (credentials) => {
  var body = JSON.stringify(credentials);

  var endpoint = global.endpoint + "/pegaso/setReview";
  fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
};
